import {FormikHelpers} from 'formik';
import {RouteComponentProps} from 'react-router-dom';
import {notify} from '@gemcook/notification';

import paths from '@paths';
import utils from '@utils';

export const sendResetMail = async (
  value: any,
  formikAction: FormikHelpers<any>,
  props: RouteComponentProps,
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>
) => {
  try {
    await utils.amplify.forgotPassword(value.email);
    props.history.push(paths.resetPassword.thank);
  } catch (error) {
    switch (error.message) {
      case 'Username/client id combination not found.':
        notify('入力されたメールアドレスは登録されていません', 'error');
        break;

      case 'User password cannot be reset in the current state.':
        setIsModal(true);
        break;

      case 'Attempt limit exceeded, please try after some time.':
        notify('時間を空けてから再度行ってください', 'error');
        break;

      case 'Cannot reset password for the user as there is no registered/verified email or phone_number':
        notify(
          'メールアドレス認証が完了していない為、パスワードリセットが行えません',
          'error'
        );
        break;

      default:
        notify('認証コードの送信に失敗しました', 'error');
        break;
    }
  } finally {
    formikAction.setSubmitting(false);
  }
};
